import { Actions } from '@space-lib/datahub'
import { Languages } from '@space-shell/constant/languages'

export type ApplicationLanguageType = 'pt-br' | Languages.En | Languages.Es | Languages.Fr

const AVAILABLE_LANGUAGES = {
  'pt-br': {
    label: 'Português - Brasil',
    value: 'pt-br',
    eventName: Actions.CLICK_PTBR_LANGUAGE_OPTIONS
  },
  es: { label: 'Español', value: Languages.Es, eventName: Actions.CLICK_ES_LANGUAGE_OPTIONS },
  en: { label: 'English', value: Languages.En, eventName: Actions.CLICK_EN_LANGUAGE_OPTIONS },
  fr: { label: 'Français', value: Languages.Fr, eventName: Actions.CLICK_FR_LANGUAGE_OPTIONS }
}

export { AVAILABLE_LANGUAGES }
